import React, { useState, useEffect } from 'react';
import RealizationCard from '../components/RealizationCard';
import RealizationLightbox from '../components/RealizationLightbox';

const categories = ['all', 'Mariage', 'Entreprise', 'Reception', 'Anniversaire', 'Festival', 'Religieux'];

const RealisationsPage = () => {
  const [realizationsData, setRealizationsData] = useState([]);
  const [selectedRealization, setSelectedRealization] = useState(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [filter, setFilter] = useState('all');

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/realizations`)
      .then(res => res.json())
      .then(data => setRealizationsData(data))
      .catch(() => {});
  }, []);

  const filteredRealizations = filter === 'all'
    ? realizationsData
    : realizationsData.filter(r => r.category === filter);

  const openGallery = (realization) => {
    setSelectedRealization(realization);
    setCurrentImageIndex(0);
  };

  const handleNext = (e) => {
    if (e) e.stopPropagation();
    if (selectedRealization) {
      setCurrentImageIndex((prev) => (prev + 1) % selectedRealization.images.length);
    }
  };

  const handlePrev = (e) => {
    if (e) e.stopPropagation();
    if (selectedRealization) {
      setCurrentImageIndex((prev) => (prev - 1 + selectedRealization.images.length) % selectedRealization.images.length);
    }
  };

  const handleSelectIndex = (idx) => {
    setCurrentImageIndex(idx);
  };

  return (
    <div className="min-h-screen bg-gray-50 pt-24" data-testid="realisations-page">
      <section className="bg-gradient-to-r from-orange-600 to-orange-700 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">Nos Réalisations</h1>
          <p className="text-xl text-orange-200 max-w-2xl mx-auto">
            Découvrez nos plus belles installations et laissez-vous inspirer pour votre prochain événement
          </p>
        </div>
      </section>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex flex-wrap gap-2 justify-center" data-testid="realisations-filters">
          {categories.map((cat) => (
            <button
              key={cat}
              onClick={() => setFilter(cat)}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-colors ${
                filter === cat ? 'bg-orange-500 text-white' : 'bg-white text-gray-700 hover:bg-orange-100'
              }`}
              data-testid={`filter-${cat}`}
            >
              {cat === 'all' ? 'Tous' : cat}
            </button>
          ))}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="realisations-grid">
          {filteredRealizations.map((item) => (
            <RealizationCard key={item.id} item={item} onClick={openGallery} />
          ))}
        </div>
      </div>

      <RealizationLightbox
        realization={selectedRealization}
        currentIndex={currentImageIndex}
        onClose={() => setSelectedRealization(null)}
        onNext={handleNext}
        onPrev={handlePrev}
        onSelectIndex={handleSelectIndex}
      />
    </div>
  );
};

export default RealisationsPage;
